module.exports = __webpack_public_path__ + "img/Butterfly_00074.ab58f99a.png";